<template>
  <nav class="nav-menu">
    <el-menu mode="horizontal" :default-active="$route.path" router>
      <el-menu-item index="/">{{ $t('nav.home') }}</el-menu-item>

      <el-submenu index="/products">
        <template slot="title">{{ $t('nav.products') }}</template>
         <el-menu-item index="/products/Solutions">{{ $t('nav.products_solutions') }}</el-menu-item>
        <el-menu-item index="/products/Devices">{{ $t('nav.products_devices') }}</el-menu-item>
      </el-submenu>

      <el-submenu index="/news">
        <template slot="title">{{ $t('nav.news') }}</template>
        <el-menu-item index="/news/company">{{ $t('nav.news_company') }}</el-menu-item>
        <el-menu-item index="/news/industry">{{ $t('nav.news_industry') }}</el-menu-item>
        <!-- <el-menu-item index="/news/NewsList">{{ $t('nav.news_tech') }}</el-menu-item> -->
      </el-submenu>

      <el-submenu index="/service">
        <template slot="title">{{ $t('nav.service') }}</template>
        <el-menu-item index="/service/support">{{ $t('nav.service_support') }}</el-menu-item>
        <el-menu-item index="/service/downloads">{{ $t('nav.service_downloads') }}</el-menu-item>
        <el-menu-item index="/service/faq">{{ $t('nav.service_faq') }}</el-menu-item>
      </el-submenu>

      <el-submenu index="/about">
        <template slot="title">{{ $t('nav.about') }}</template>
        <el-menu-item index="/about/company">{{ $t('nav.about_company') }}</el-menu-item>
        <el-menu-item index="/about/team">{{ $t('nav.about_team') }}</el-menu-item>
      </el-submenu>

      <el-menu-item index="/contact">{{ $t('nav.contact') }}</el-menu-item>
    </el-menu>
  </nav>
</template>

<script>
export default { name: 'NavMenu' }
</script>

<style scoped>
.nav-menu .el-menu {
  border-bottom: none;
  background: transparent;
}

/* 主菜单 hover 效果 */
.nav-menu .el-menu-item:hover,
.nav-menu .el-submenu__title:hover {
  background-color: #f5f7fa !important; /* 浅灰 hover 背景 */
  color: #409EFF !important; /* Element Plus 主色 */
  border-radius: 4px;
}

/* 主菜单激活状态 */
.nav-menu .el-menu-item.is-active,
.nav-menu .el-submenu.is-active > .el-submenu__title {
  background-color: #409EFF !important;
  color: #fff !important;
  border-radius: 4px;
}

/* 去掉默认底线高亮 */
.nav-menu .el-menu--horizontal > .el-menu-item.is-active::after,
.nav-menu .el-menu--horizontal > .el-submenu.is-active::after {
  display: none;
}

/* 响应式隐藏 */
@media (max-width: 800px) {
  .nav-menu {
    display: none;
  }
}
</style>


